import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { userDataType } from "../pages/Login";

export default function useMy() {
  const userData = useRecoilValue(userDataType);

  useEffect(() => {}, [userData]);

  return {
    grade: userData?.grade,
    name: userData?.name,
    email: userData?.email,
  };
}
